import { radioAnatomy as s } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers as y, defineStyle as m } from "@chakra-ui/styled-system";
import { mode as t } from "@chakra-ui/theme-tools";
import { checkboxTheme as c } from "./checkbox.mjs";
const { defineMultiStyleConfig: C, definePartsStyle: n } = y(s.keys), h = m((o) => {
  const { colorScheme: e } = o, r = t("".concat(e, ".500"), "".concat(e, ".200"))(o), l = t("".concat(e, ".300"), "".concat(e, ".800"))(o), d = "coldGray.300", i = "coldGray.100", a = "primary.300", b = "primary.200";
  return {
    borderRadius: "full",
    border: "1px solid",
    borderColor: r,
    _checked: {
      color: r,
      borderColor: r,
      bg: t("white", "gray.900")(o),
      _hover: {
        color: l,
        borderColor: t("".concat(e, ".600"), "".concat(e, ".300"))(o)
      },
      _disabled: {
        borderColor: l,
        color: l
      },
      _readOnly: {
        borderColor: a,
        color: a,
        bg: b
      },
      // Center dot
      _before: {
        content: '""',
        display: "inline-block",
        pos: "relative",
        w: "60%",
        h: "60%",
        borderRadius: "50%",
        bg: "currentColor"
      }
    },
    _indeterminate: {
      bg: r,
      borderColor: r,
      color: t("white", "gray.900")(o)
    },
    _disabled: {
      borderColor: l
    },
    _readOnly: {
      borderColor: d,
      bg: i
    },
    _focus: {
      boxShadow: "outline",
      _readOnly: {
        boxShadow: "unset"
      }
    },
    _invalid: {
      borderColor: t("red.500", "red.300")(o)
    }
  };
}), f = n((o) => {
  var e, r, l, d;
  return {
    label: (r = (e = c).baseStyle) == null ? void 0 : r.call(e, o).label,
    container: (d = (l = c).baseStyle) == null ? void 0 : d.call(l, o).container,
    control: h(o)
  };
}), S = {
  md: n({
    control: { w: "5", h: "5" },
    label: { fontSize: "md" }
  }),
  lg: n({
    control: { w: "6", h: "6" },
    label: { fontSize: "lg" }
  }),
  sm: n({
    control: { width: "4", height: "4" },
    label: { fontSize: "sm" }
  })
}, O = C({
  baseStyle: f,
  sizes: S,
  defaultProps: {
    size: "md",
    colorScheme: "primary"
  }
});
export {
  O as radioTheme
};
